import { render } from "./MultiPositionField.vue?vue&type=template&id=78a14570&scoped=true"
import script from "./MultiPositionField.vue?vue&type=script&lang=js"
export * from "./MultiPositionField.vue?vue&type=script&lang=js"

import "./MultiPositionField.vue?vue&type=style&index=0&id=78a14570&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a14570"]])

export default __exports__